import React from "react";
import { Chip } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";

const countAttachmentsByType = (attachments) => {
  const list = Array.isArray(attachments) ? attachments : [];
  const videos = list.filter((a) => a.mediaType === "video").length;
  const images = list.filter((a) => a.mediaType === "image").length;
  const docs = list.filter(
    (a) => a.mediaType === "document" || a.mediaType === "raw",
  ).length;
  return { videos, images, docs };
};

const activate = (event, onClick) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    onClick?.();
  }
};

export const KBListItem = ({ article, onClick }) => {
  const { videos, images, docs } = countAttachmentsByType(article.attachments);
  const totalAttach = videos + images + docs;

  return (
    <div
      className="kb-article-row"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => activate(e, onClick)}
    >
      <span className="kb-article-row__icon" aria-hidden>
        <ArticleIcon />
      </span>

      <div className="kb-article-row__body">
        <div className="kb-article-row__title-row">
          <p className="kb-article-row__title">{article.title}</p>
          {article.productType && (
            <Chip
              className="kb-chip kb-chip--navy"
              label={article.productType}
              size="small"
            />
          )}
          <Chip
            className="kb-chip"
            label={article.moduleName || article.moduleSlug}
            size="small"
          />
        </div>
        {article.shortDescription && (
          <p className="kb-article-row__desc">{article.shortDescription}</p>
        )}
      </div>

      <div className="kb-article-row__meta">
        <div className="kb-meta-stats">
          {totalAttach > 0 && (
            <>
              {videos > 0 && (
                <span className="kb-meta-stat">
                  <VideocamOutlinedIcon />
                  {videos}
                </span>
              )}
              {images > 0 && (
                <span className="kb-meta-stat">
                  <ImageOutlinedIcon />
                  {images}
                </span>
              )}
              {docs > 0 && (
                <span className="kb-meta-stat">
                  <DescriptionOutlinedIcon />
                  {docs}
                </span>
              )}
            </>
          )}
          <span className="kb-meta-stat is-up">
            <ThumbUpAltOutlinedIcon />
            {article.totalHelpful || 0}
          </span>
          <span className="kb-meta-stat is-down">
            <ThumbDownAltOutlinedIcon />
            {article.totalUnhelpful || 0}
          </span>
        </div>
      </div>
    </div>
  );
};
